import React from 'react';
import { Card, CardHeader, CardContent, Avatar, Typography, Box, Radio } from '@mui/material';
import './PostCard.css'
import { PostType } from './PostApprovalScreen';
import { formatDate } from './SocialService';

interface PostCardPropsType {
  post: PostType
  isSelected: boolean,
  onSelect: () => void
}

const PostCard = ({ post, isSelected, onSelect }: PostCardPropsType) => {

  const { userImage, outletname, name, time, content, postType } = post
  return (
    <div className='post_card_parent_container'>
      <Radio
        checked={isSelected}
        onChange={onSelect}
        sx={{
          padding: 0,
          marginRight: 1,
          '&:hover': {
            backgroundColor: 'transparent',
          },
          '&.Mui-checked': {
            color: 'var(--dashboard-theme-color)',
          },
        }}
      />

      <Card
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: 1,
          borderRadius: '8px',
          boxShadow: 'none',
          width: '100%',
          background: `${isSelected ? 'transparent linear-gradient(270deg, #FFFFFF 0%, #EFFBFF 100%) 0% 0% no-repeat padding-box;' : ''}`
        }}
      >


        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <CardHeader
            avatar={
              <Avatar src={userImage} alt={name} sx={{ height: 30, width: 30 }} />
            }
            title={
              <span className='post_card_header' style={{ display: 'flex', }}>
                <span id='post_card_outlet_name' >
                  {outletname}
                </span>
                <span id='post_card_name'>
                  &nbsp;- {name}
                </span>
                <span id='post_card_header_text'> &nbsp; wants to share a {`${postType=="survey"?"survey":"post"}`}</span>
              </span>
            }
            subheader={
              <span id='post_card_header_time'>
                {formatDate(time)}
              </span>
            }
            sx={{ padding: 0, marginBottom: 1, lineHeight: '16px' }}
          />
          <CardContent sx={{ width: "97%", borderRadius: '5px', padding: '5px 4px !important', background: `${!isSelected ? 'transparent linear-gradient(270deg, #F7F7F700 0%, #F4F4F4 100%) 0% 0% no-repeat padding-box;' : ''}` }}>
            <Typography
              variant="body2"
              color={`${isSelected ? '#2F7D9D' : 'text.secondary'}`}
              noWrap
            >
              {content}
            </Typography>
          </CardContent>
        </Box>
      </Card>

    </div>
  );
};

export default PostCard;

